import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from './services/auth.service';
import * as Parse from 'parse';
import {environment} from '../environments/environment';

Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
(Parse as any).serverURL = environment.serverURL;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'despacho';

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.startLiveQueryCurrentUser();
  }

  ngOnDestroy() {
    this.authService.stopLiveQueryCurrentUser();
  }
}
